import { knob, track } from './Toggle.css'

export type ToggleProps = {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  id?: string
  ariaLabel?: string
  'aria-describedby'?: string
  'data-testid'?: string
}

export function Toggle({
  checked,
  onChange,
  disabled = false,
  id,
  ariaLabel,
  'aria-describedby': describedBy,
  'data-testid': testId,
}: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      id={id}
      aria-checked={checked}
      aria-label={ariaLabel}
      aria-describedby={describedBy}
      disabled={disabled}
      data-testid={testId}
      className={track({ checked, disabled })}
      onClick={() => {
        onChange(!checked)
      }}
    >
      <span className={knob({ checked })} />
    </button>
  )
}
